import React from 'react';
import './HeaderComponent.css'

const HeaderComponent = ({initialSurvey}) => {
	
	return(
		<div className='header-component'>
			<div className='dis-flex flex-column p-l-6'>
				<div className='dis-flex  flex-row justify-space-around'>
					<div>
						<img src='./ln_logo_transparent_background.png' height={100} alt='Transparent Logo'></img>
					</div>
				</div>
			</div>
		</div>
	)
}

export default HeaderComponent;